import { IAnalyticsEventSlack } from './types';

export const slackIntegrationConnected = (): IAnalyticsEventSlack => {
  return {
    eventName: 'Slack Integration Connected',
  };
};

export const slackIntegrationDisconnected = (): IAnalyticsEventSlack => {
  return {
    eventName: 'Slack Integration Disconnected',
  };
};
